export const ServiceProviderSymbol = Symbol('ServiceProvider')
export const SignalsPageServiceProviderSymbol = Symbol('SignalsPageServiceProvider')
export const SignalsServiceProviderSymbol = Symbol('SignalsServiceProvider')
export const ServicesManagerSymbol = Symbol('ServicesManager')
export const PageServicesManagerSymbol = Symbol('PageServicesManager')
export const SiteServicesProviderSymbol = Symbol('SiteServicesProvider')
